import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

import {CreateContainerSchemaParams, UpdateContainerSchemaParams} from './SampleSchemaActions';
import {ContainerSchema} from './storables/StorableSchemaConstants';

interface CreateContainerSchemaParamsWithRegistryId extends CreateContainerSchemaParams {
  registryId: string;
}

export function fetchAll(): JQueryPromise<{data: Array<ContainerSchema>}> {
  return net.getJSON('/1/api/container-schemas');
}

export function create(data: CreateContainerSchemaParamsWithRegistryId): JQueryPromise<ContainerSchema> {
  return net.postJSON({url: '/1/api/container-schemas', data});
}

export function update(
  containerSchemaId: string,
  data: UpdateContainerSchemaParams
): JQueryPromise<ContainerSchema> {
  return TaskRunner.patchJSON({url: `/1/api/container-schemas/${containerSchemaId}`, data});
}

export function deleteContainerSchema(containerSchemaId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/container-schemas/${containerSchemaId}`});
}
